module.exports = __webpack_public_path__ + "static/media/continueSingpass.0bb022eb.png";